module.exports = __webpack_public_path__ + "media/images/e-bilet/directions/kyiv-kharkiv-93c63f83f3236fb6f6a00343d036d2e3.png";